<template>
  <div class="EngineerList">
    <div class="operatePanel">
      <el-form ref="selectedform" label-width="68px" :inline="true">
        <el-row>
          <el-col :span="5">
            <el-form-item label="细目号">
              <el-input v-model="selectedform.subCategoryNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="细目名称">
              <el-input
                v-model="selectedform.subCategoryName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-button type="primary" @click="handleSearch()">查询</el-button>
            <el-button type="info" @click="handleReset()">重置</el-button>
            <el-button type="primary" @click="choiceSubEngineer()"
              >添加(定额)</el-button
            >
            <el-button type="primary" @click="choiceSubGood()"
              >添加(物资)</el-button
            >
            <!-- <el-button type="primary" icon="el-icon-plus" @click="saveSubEngineer()">保存</el-button> -->
            <el-button type="primary" @click="DelectSubEngineer()">删除</el-button>
            <el-button type="primary" @click="setDecimalShow()"
              >设置位数</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <!-- <el-button title="下载模板" type="primary" icon="el-icon-download" @click="downTemplate()">下载模板</el-button>
      <el-button title="导入合同" type="primary" icon="el-icon-upload2" @click="importSubEngineer()">导入</el-button> -->
    </div>
    <el-table
      ref="multipleTables"
      :data="subtableData"
      height="calc(100vh - 238px)"
      stripe
      border
      size="mini"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @row-click="rowClicked"
      :row-class-name="setRowClassName"
      :show-summary="showSum"
      :summary-method="getSummaries"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        show-overflow-tooltip
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.column.property == 'materialPrice'">
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row[scope.column.property]"
            ></el-input>
            <div v-if="!scope.row.isEdit">
              {{ scope.row[scope.column.property] | numFilter }}
            </div>
          </div>
          <div v-else-if="scope.column.property == 'unit'">
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row[scope.column.property]"
            ></el-input>
            <div v-if="!scope.row.isEdit">
              {{ scope.row[scope.column.property] }}
            </div>
          </div>
          <div v-else-if="scope.column.property == 'quantity'">
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row[scope.column.property]"
            ></el-input>
            <div v-if="!scope.row.isEdit">
              {{ scope.row[scope.column.property] }}
            </div>
          </div>
          <div v-else-if="scope.column.property == 'taxRate'">
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row[scope.column.property]"
            ></el-input>
            <div v-if="!scope.row.isEdit">
              {{ scope.row[scope.column.property] }}
            </div>
          </div>
          <!-- 中标裸税单价 -->
          <div v-else-if="scope.column.property == 'bidPrice'">
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row[scope.column.property]"
            ></el-input>
            <div v-if="!scope.row.isEdit">
              {{ scope.row[scope.column.property] }}
            </div>
          </div>
          <div v-else-if="scope.column.property == 'remarks'">
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row[scope.column.property]"
            ></el-input>
            <div v-if="!scope.row.isEdit">
              {{ scope.row[scope.column.property] }}
            </div>
          </div>
          <div v-else-if="scope.column.property == 'totalPrice'">
            <div>
              {{
                scope.row[scope.column.property] | numFilter
              }}
            </div>
          </div>
          <!-- 只有劳务合同展示指导劳务单价-->
          <div v-else-if="scope.column.property == 'guideLaborPrice'">
            <div v-if="contractType === 'LABOR'">
              {{ scope.row[scope.column.property] }}
            </div>
          </div>
          <span v-else>{{ scope.row[scope.column.property] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="96">
        <template slot-scope="scope">
          <el-button
            type="plain"
            v-if="scope.row.isEdit"
            @click="saveChange(scope.row)"
            >保存</el-button
          >
          <el-button type="plain" v-else @click="editSingleTable(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 选择内部定额表子目弹框 -->
    <el-dialog
      title="选择子目(内部定额表)"
      :visible.sync="subEngineerdialogVisible"
      width="60%"
      height="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="form" label-width="100px" :inline="true">
          <el-row>
            <el-col :span="8">
              <el-form-item label="细目号">
                <el-input v-model="subCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="细目名称">
                <el-input
                  v-model="subCategoryName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="primary" @click="initList()">查询</el-button>
              <el-button type="info" @click="resetClick()">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        ref="multipleTable1"
        :data="alltableData"
        border
        size="mini"
        style="width: 100%"
        height="500px"
        @selection-change="handlesubSelectionChange"
        :row-class-name="setRowClassName"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          v-for="(item, index) in subtableColumnDatas"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="totalCount"
        ></el-pagination>
      </el-footer>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="subEngineerdialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="confirmsubEngineer">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入工程量清单子目 -->
    <!-- <upload-dialog
      :isShow="showUploadDialog"
      @close="closeDialogAction"
      :isImportContract="isImportengineerDialog"
      @saveImportItems="saveImportItems"
    /> -->
    <!-- 选择物资清单子目弹框 -->
    <el-dialog
      title="选择子目(物资清单)"
      :visible.sync="subGooddialogVisible"
      width="60%"
      height="600px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form ref="form" label-width="100px" :inline="true">
          <el-row>
            <el-col :span="8">
              <el-form-item label="存货">
                <el-input v-model="productNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="存货名称">
                <el-input v-model="productName" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button type="primary" @click="initProductList()"
                >查询</el-button
              >
              <el-button type="info" @click="resetClick2()">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        ref="multipleTable2"
        :data="allproducttableData"
        border
        size="mini"
        style="width: 100%"
        height="530px"
        @selection-change="handlesubSelectionChange"
        :row-class-name="setRowClassName"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          v-for="(item, index) in subproducttableColumnDatas"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageIndex2"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize2"
          layout="total, prev, pager, next, sizes, jumper"
          :total="totalCount2"
        ></el-pagination>
      </el-footer>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="subGooddialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="confirmsubGood">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import UploadDialog from "./UploadEngineerDialog"; //导入工程量清单子目组件
import {
  getOtherDetailsListService, //获取内部定额表全部子目列表
  getallSubGoodListService, //获取采购物资子目table数据
  getallSubEngineerListService, //获取工程量子目table数据
  deleteoneSubEngineerSevice, //删除选中的一条子目
  exportExcelService2, //导出
  getTemplate, //下载导入模板
} from "@/services/allContractServices";
import { accMul, numFilter, filterData,newFixed } from "@/utils/filters";
export default {
  name: "EngineerList",
  components: {
    // UploadDialog,
  },
  props: {
    engineerItems: {
      type: Array,
    },
    contractType: {
      type: String,
      default: "",
    },
    pointSettingDto: {
      type: Object,
    },
  },
  data() {
    return {
      subEngineerdialogVisible: false, //选择内部定额表子目对话框可见性
      subGooddialogVisible: false, //物资清单对话框可见性
      selectItems: [], //记录选中的要删除的子目
      selectsubItems: [], //记录选中的子目
      showUploadDialog: false, //导入对话框展示与否
      isImportengineerDialog: true, //true为导入工程量清单可见性
      originPrice: 0, //记录每条记录编辑前的价格
      showSum: true, //是否展示合计行
      tableColumnDatas: [
        // { class: "subCategoryNo", labelName: "序号", sortEnable: false },
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "typeShow", labelName: "类型", sortEnable: false },
        {
          class: "materialCoefficient",
          labelName: "材料系数",
          sortEnable: false,
        },
        { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        { class: "materialPrice", labelName: "材料单价", sortEnable: false },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "guideLaborPrice",
          labelName: "指导劳务单价",
          sortEnable: false,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率(%)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "synthesizePriceAfterTax",
          labelName: "税后综合单价",
          sortEnable: false,
          isNumFilter: true,
        },

        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价",
          sortEnable: false,
          isNumFilter: true,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      labeltableColumnDatas: [
        // { class: "subCategoryNo", labelName: "序号", sortEnable: false },
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "typeShow", labelName: "类型", sortEnable: false },
        {
          class: "materialCoefficient",
          labelName: "材料系数",
          sortEnable: false,
        },
        { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        { class: "materialPrice", labelName: "材料单价", sortEnable: false },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "guideLaborPrice",
          labelName: "指导劳务单价",
          sortEnable: false,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率(%)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "synthesizePriceAfterTax",
          labelName: "税后综合单价",
          sortEnable: false,
          isNumFilter: true,
        },

        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价",
          sortEnable: false,
          isNumFilter: true,
        },
        { class: "model", labelName: "规格型号", sortEnable: false },
        { class: "factoryName", labelName: "厂商", sortEnable: false },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      othertableColumnDatas: [
        // { class: "subCategoryNo", labelName: "序号", sortEnable: false },
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "typeShow", labelName: "类型", sortEnable: false },
        {
          class: "materialCoefficient",
          labelName: "材料系数",
          sortEnable: false,
        },
        { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        { class: "materialPrice", labelName: "材料单价", sortEnable: false },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率",
          sortEnable: false,
          isNumFilter: true,
        },
        // {
        //   class: "synthesizePriceAfterTax",
        //   labelName: "税后综合单价",
        //   sortEnable: false,
        //   isNumFilter: true,
        // },

        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价",
          sortEnable: false,
          isNumFilter: true,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      subtableColumnDatas: [
        // { class: "serialNumber", labelName: "序号", sortEnable: false },
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "typeShow", labelName: "类型", sortEnable: false },
        {
          class: "materialCoefficient",
          labelName: "材料系数",
          sortEnable: false,
        },
        { class: "calculateFormula", labelName: "计算公式", sortEnable: false },
        {
          class: "guideLaborPrice",
          labelName: "指导劳务单价",
          sortEnable: false,
        },
        { class: "unit", labelName: "单位", sortEnable: false },
        // { class: "quantity", labelName: "数量", sortEnable: false },
        { class: "materialPrice", labelName: "单价", sortEnable: false },
        // { class: "totalPrice", labelName: "金额", sortEnable: false },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      //物资清单选择列弹窗
      subproducttableColumnDatas: [
        // { class: "serialNumber", labelName: "序号", sortEnable: false },
        { class: "productNumber", labelName: "存货编码", sortEnable: false },
        { class: "productName", labelName: "存货名称", sortEnable: false },
        //  { value: "材料", labelName: "类型", sortEnable: false },
        { class: "model", labelName: "规格型号", sortEnable: false },
        { class: "factoryName", labelName: "厂商", sortEnable: false },
        { class: "unit", labelName: "计量单位", sortEnable: false },
        // { class: "amount", labelName: "数量", sortEnable: false },
        { class: "unitPrice", labelName: "单价", sortEnable: false },
        { class: "remarks", labelName: "备注", sortEnable: false },
        // { class: "applyUserName", labelName: "金额", sortEnable: false }
      ],
      showAdvanceFilter: false,
      selectedform: {
        //已选择条目的查询条件
        subCategoryNo: "", //弹窗查询条件
        subCategoryName: "", //弹窗查询条件
      },
      subCategoryNo: "", //弹窗查询条件
      subCategoryName: "", //弹窗查询条件
      productNumber: "",
      productName: "",
      pageIndex: 1,
      pageSize: 50,
      totalCount: 0,
      pageIndex2: 1,
      pageSize2: 50,
      totalCount2: 0,
      tableData: [], //已选择的子目名称
      subtableData: [], //帅选的子目名称
      alltableData: [], //所有定额表子目列表
      allproducttableData: [], //所有物资清单子目列表
      showExportDialog: false,
      btnAuthorize: {
        addBtn: { btnCode: "2019083113431682867", btnEnable: false },
        exportBtn: { btnCode: "2019083113425679801", btnEnable: false },
        advanceExportBtn: { btnCode: "2019083113434955027", btnEnable: false },
        multiSendBtn: { btnCode: "2019102309190963305", btnEnable: false },
      },
    };
  },
  created() {
    this.pageIndex = 1;
    // this.initList(); //获取列表  gaa 20200826
    this.pageIndex2 = 1;
    // this.initProductList(); //获取列表  gaa 20200826
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.multipleTables.doLayout();
    });
  },
  mounted() {
    if (this.contractType === "LABOR") {
      this.tableColumnDatas = this.labeltableColumnDatas;
    }
    // else {
    //   this.tableColumnDatas = this.othertableColumnDatas;
    // }
  },
  watch: {
    engineerItems(newVal) {
      if (newVal && newVal.length > 0) {
        this.tableData = newVal;
      } else {
        this.tableData = [];
      }
      this.subtableData = this.tableData;
    },
    "pointSettingDto.totalPurePrice": {
      handler: function (newValue, oldValue) {
        this.setDecimalFun('totalPurePrice');
      },
      // 如果需要深度监听对象内部的变化，请设置deep选项为true
      deep: true,
    },
    "pointSettingDto.totalPriceAfterTax": {
      handler: function (newValue, oldValue) {
        this.setDecimalFun('totalPriceAfterTax');
      },
      // 如果需要深度监听对象内部的变化，请设置deep选项为true
      deep: true,
    },
    // contractType(newVal) {
    //   if (newVal === "LABOR") {
    //     this.tableColumnDatas = this.labeltableColumnDatas;
    //   }
    //   else {
    //     this.tableColumnDatas = this.othertableColumnDatas;
    //   }
    // },
  },
  methods: {
    setDecimalFun(type) {
      switch (type) {
        case "totalPurePrice":
          this.subtableData.forEach((item) => {
            if (item.taxRate !== "" && item.materialPrice !== "") {
              item.totalPurePrice = accMul(
                item.quantity,
                item.bidPrice
              )
              item.totalPurePrice=newFixed(item.totalPurePrice,this.pointSettingDto.totalPurePrice);
              item.totalPriceAfterTax = accMul(
                item.totalPurePrice,
                1 + item.taxRate / 100
              )
              item.totalPriceAfterTax=newFixed(item.totalPriceAfterTax,this.pointSettingDto.totalPriceAfterTax);
            }
            return item;
          });
          break;
        case "totalPriceAfterTax": //税后合价
          this.subtableData.forEach((item) => {
            if (item.taxRate !== "" && item.materialPrice !== "") {
              item.totalPriceAfterTax = accMul(
                item.totalPurePrice,
                1 + item.taxRate / 100
              )
              item.totalPriceAfterTax=newFixed(item.totalPriceAfterTax,this.pointSettingDto.totalPriceAfterTax);
            }
            return item;
          });
          break;
      }
    },
    setDecimalShow() {
      this.$emit("setDecimalShow");
    },
    initList() {
      let dictIdSet = this.tableData?.map((v) => v.dictId || v.id) ?? [];
      let param = {
        subCategoryNo: this.subCategoryNo, //弹窗查询条件
        subCategoryName: this.subCategoryName, //弹窗查询条件
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        dictIdSet: dictIdSet,
      };
      getOtherDetailsListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.alltableData = res.data;
            this.totalCount = res.total;
            try {
              this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
            } catch (error) {
              console.log("-- tableHeight error\n", error);
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          // this.$message.error(error.msg);
        });
    }, //
    resetClick() {
      this.subCategoryNo = ""; //弹窗查询条件
      this.subCategoryName = ""; //弹窗查询条件
      this.pageIndex = 1;
      this.pageSize = 10;
      this.initList();
    },
    resetClick2() {
      this.productNumber = ""; //弹窗查询条件
      this.productName = ""; //弹窗查询条件
      this.pageIndex2 = 1;
      this.pageSize2 = 10;
      this.initProductList();
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.pageSize = rows;
      this.pageIndex = 1;
      this.initList();
    },
    /* 分页改变事件 */
    handleCurrentChange2(page) {
      this.pageIndex2 = page;
      this.initProductList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange2(rows) {
      this.pageSize2 = rows;
      this.pageIndex2 = 1;
      this.initProductList();
    },
    //审批关闭
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //选择要删除的工程量清单子目
    handleSelectionChange(val) {
      this.selectItems = val;
      console.log(val);
    },
    //已选中的要添加的工程量清单子目
    handlesubSelectionChange(val) {
      this.selectsubItems = val;
      console.log(val);
    },
    setRowClassName({ row, rowIndex }) {
      if (row.isOverTime != 0) {
        return "overTimeMark";
      }
    }, //
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTables.toggleRowSelection(row);
    },
    // 查询
    handleSearch() {
      this.subtableData = filterData(this.selectedform, this.tableData);
    },
    handleReset() {
      this.selectedform = {
        subCategoryNo: "", //弹窗查询条件
        subCategoryName: "", //弹窗查询条件
      };
      this.subtableData = filterData(this.selectedform, this.tableData);
    },

    //导入工程量清单子目
    importSubEngineer() {
      this.isImportengineerDialog = true;
      this.showUploadDialog = true;
    },

    //删除选中的子目
    DelectSubEngineer() {
      if (this.selectItems.length < 1) {
        this.$alert("请至少选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$confirm("确认删除该条子目吗?", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        for (let i = 0; i < this.selectItems.length; i++) {
          for (let j = 0; j < this.tableData.length; j++) {
            if (this.tableData[j].dictId == this.selectItems[i].dictId) {
              this.tableData.splice(j, 1);
              this.$emit("saveUnionItems", this.tableData);
              this.subtableData = filterData(this.selectedform, this.tableData);
              break;
            }
          }
        }
      });
    },

    //保存选中的子目
    saveSubEngineer() {
      this.$emit("saveUnionItems", this.tableData);
    },
    //打开工程量清单选择子目对话框
    choiceSubEngineer() {
      // this.Approveform.ownerName = this.Contractform.groupCode;
      this.initList(); //获取工程量清单子目选择table数据
      this.subEngineerdialogVisible = true;
    },
    choiceSubGood() {
      // this.Approveform.ownerName = this.Contractform.groupCode;
      this.initProductList(); //获取工程量清单子目选择table数据
      this.subGooddialogVisible = true;
    },
    initProductList() {
      let dictIdSet = this.tableData?.map((v) => v.dictId || v.id) ?? [];
      let param = {
        productNumber: this.productNumber,
        productName: this.productName,
        pageIndex: this.pageIndex2,
        pageSize: this.pageSize2,
        dictIdSet: dictIdSet,
      };
      getallSubGoodListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.allproducttableData = res.data;
            this.totalCount2 = res.total;
            // this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
            try {
              this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
            } catch (error) {
              console.log("-- tableHeight error\n", error);
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          // this.$message.error("系统异常");
        });
    }, //

    //确认定额表对话框选择的子目数据
    confirmsubEngineer() {
      if (this.selectsubItems.length < 1) {
        this.$alert("请至少选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {};
      this.$confirm("确认保存吗？", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        let addFlag = true;
        if (this.tableData.length > 0) {
          for (let i = 0; i < this.selectsubItems.length; i++) {
            for (let j = 0; j < this.tableData.length; j++) {
              if (this.tableData[j].dictId == this.selectsubItems[i].id) {
                addFlag = false;
                break;
              }
            }
            if (addFlag) {
              this.selectsubItems[i].dictId = this.selectsubItems[i].id;
              this.selectsubItems[i].quantity = 0;
              this.selectsubItems[i].taxRate = 0; //税率
              this.selectsubItems[i].synthesizePriceAfterTax = 0; //税后综合单价
              this.selectsubItems[i].totalPurePrice = 0; //裸税合价
              this.selectsubItems[i].totalPriceAfterTax = 0; //税后合价
              this.selectsubItems[i].totalPrice = 0; //金额
              //中标裸税单价默认为0
              this.selectsubItems[i].bidPrice = 0;

              this.selectsubItems[i].isEdit = false;
              // if (this.contractType === "LABOR") {
              //   this.selectsubItems[i].bidPrice =
              //     this.selectsubItems[i].guideLaborPrice; //中标裸税单价默认=指导劳务单价
              // } else {
              //   this.selectsubItems[i].bidPrice =
              //     this.selectsubItems[i].materialPrice;
              // }
              let item = { ...this.selectsubItems[i] };
              this.tableData.push(item);
            }
            addFlag = true;
          }
        } else {
          for (let i = 0; i < this.selectsubItems.length; i++) {
            this.selectsubItems[i].dictId = this.selectsubItems[i].id;
            this.selectsubItems[i].quantity = 0;
            this.selectsubItems[i].isEdit = false;
            this.selectsubItems[i].taxRate = 0; //税率
            this.selectsubItems[i].totalPrice = 0; //金额
            this.selectsubItems[i].bidPrice = 0;
            // if (this.contractType === "LABOR") {
            //   this.selectsubItems[i].bidPrice =
            //     this.selectsubItems[i].guideLaborPrice; //中标裸税单价默认=指导劳务单价
            // } else {
            //   this.selectsubItems[i].bidPrice =
            //     this.selectsubItems[i].materialPrice;
            // }
            this.selectsubItems[i].synthesizePriceAfterTax = 0; //税后综合单价

            this.selectsubItems[i].totalPurePrice = 0; //裸税合价
            this.selectsubItems[i].totalPriceAfterTax = 0; //税后合价
            let item = { ...this.selectsubItems[i] };
            this.tableData.push(item);
          }
          console.log(this.tableData[0]);
        }
        this.subEngineerdialogVisible = false;
        this.$emit("saveUnionItems", this.tableData);
        this.handleReset();
      });
    },

    //确认物资清单对话框选择的子目数据
    confirmsubGood() {
      if (this.selectsubItems.length < 1) {
        this.$alert("请至少选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {};
      this.$confirm("确认保存吗？", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        if (this.tableData.length > 0) {
          for (let i = 0; i < this.selectsubItems.length; i++) {
            let index=this.tableData.findIndex(item=>item.dictId==this.selectsubItems[i].id)
            if (index==-1) {
              this.selectsubItems[i].subCategoryNo =  this.selectsubItems[i].productNumber;
              this.selectsubItems[i].subCategoryName = this.selectsubItems[i].productName;
              this.selectsubItems[i].materialPrice = this.selectsubItems[i].unitPrice;
              this.selectsubItems[i].dictId = this.selectsubItems[i].id;
              this.selectsubItems[i].quantity = 0;
              this.selectsubItems[i].isEdit = false;
              this.selectsubItems[i].taxRate = 0; //税率
              this.selectsubItems[i].bidPrice = 0;
              // this.selectsubItems[i].unitPrice; //中标裸税单价 中标裸税单价=单价/(1+税率)
              this.selectsubItems[i].totalPurePrice = 0; //裸税合价
              this.selectsubItems[i].totalPurePrice = 0; //裸税合价
              this.selectsubItems[i].totalPurePrice = 0; //裸税合价
              let item = { ...this.selectsubItems[i] };
              this.tableData.push(item);
            }
          }
        } else {
          for (let i = 0; i < this.selectsubItems.length; i++) {
            this.selectsubItems[i].subCategoryNo =
              this.selectsubItems[i].productNumber;
            this.selectsubItems[i].subCategoryName =
              this.selectsubItems[i].productName;
            this.selectsubItems[i].materialPrice =
              this.selectsubItems[i].unitPrice;
            this.selectsubItems[i].dictId = this.selectsubItems[i].id;
            this.selectsubItems[i].quantity = 0;
            this.selectsubItems[i].isEdit = false;
            this.selectsubItems[i].taxRate = 0; //税率
            this.selectsubItems[i].bidPrice = 0; //中标裸税单价;
            this.selectsubItems[i].totalPurePrice = 0; //裸税合价
            let item = { ...this.selectsubItems[i] };
            this.tableData.push(item);
          }
        }
        this.subGooddialogVisible = false;
        this.$emit("saveUnionItems", this.tableData);
        this.handleReset();
      });
    },
    //关闭导入对话框
    closeDialogAction() {
      this.showUploadDialog = false;
    },
    closeDialog() {
      this.showExportDialog = false;
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },

    //下载工程里清单合同模板
    downTemplate() {
      let category = "PROJECT_DETAILS"; //工程量清单模板
      getTemplate(category).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              // this.$alert("成功", "提示", {
              //   confirmButtonText: "确定"
              // });
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          // this.$message.error(err.msg);
        }
      );
    },

    //保存导入的工程量清单
    saveImportItems(selectItems) {
      if (selectItems.length > 0) {
        for (let i = 0; i < selectItems.length; i++) {
          selectItems[i].quantity = 0;
          selectItems[i].isEdit = false;
          selectItems[i].taxRate = 0; //税率
          selectItems[i].totalPrice = 0; //金额
          selectItems[i].synthesizePriceAfterTax = 0; //税后综合单价
          selectItems[i].totalPurePrice = 0; //裸税合价
          selectItems[i].bidPrice = 0;
          // if (this.contractType === "LABOR") {
          //   selectItems[i].bidPrice = selectItems[i].guideLaborPrice; //中标裸税单价默认=指导劳务单价
          // } else {
          //   selectItems[i].bidPrice = selectItems[i].materialPrice;
          // }

          selectItems[i].totalPriceAfterTax = 0; //税后合价
          let item = { ...selectItems[i] };
          this.tableData.push(item);
        }
      }
      this.showUploadDialog = false;
      this.$emit("saveUnionItems", this.tableData);
      this.handleReset();
    },
    /**
     * 当前表格的数量、备注修改
     * @param
     * row   Object  当前选中的行数据
     **/
    saveChange(row) {
      if (row.quantity !== "" && row.materialPrice !== "") {
        row.totalPrice = accMul(row.quantity, row.materialPrice);
      } else {
        row.totalPrice = "";
      }
      if (row.taxRate !== "" && row.materialPrice !== "") {
        row.synthesizePriceAfterTax = accMul(
          row.bidPrice,
          1 + row.taxRate / 100
        )
        row.synthesizePriceAfterTax=newFixed( row.synthesizePriceAfterTax,2);
        // if (this.contractType !== "LABOR") {
        //   row.bidPrice = (row.materialPrice / (1 + row.taxRate / 100)).newFixed(
        //     2
        //   );
        // }
        row.totalPurePrice = accMul(row.quantity, row.bidPrice)
        row.totalPurePrice = newFixed( row.totalPurePrice,
          this.pointSettingDto.totalPurePrice
        );
        row.totalPriceAfterTax = accMul(
          row.totalPurePrice,
          1 + row.taxRate / 100
        )
        row.totalPriceAfterTax =newFixed(row.totalPriceAfterTax ,this.pointSettingDto.totalPriceAfterTax);
      } else {
        row.synthesizePriceAfterTax = "";
        // row.bidPrice = "";
        row.totalPurePrice = "";
        row.totalPriceAfterTax = "";
      }
      row.isEdit = false;
      this.$emit("saveUnionItems", this.tableData);
      let index = this.tableData.findIndex((item) => {
        item.id === row.id;
      });
      this.tableData[index] = row;
      this.subtableData = filterData(this.selectedform, this.tableData);
    },
    editSingleTable(row) {
      row.isEdit = false;
      this.$nextTick().then(() => {
        row.isEdit = true;
      });
      this.originPrice = row.materialPrice;
    },

    //设置小计
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 7) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "quantity" ||
            column.property == "totalPrice" ||
            column.property == "totalPurePrice" ||
            column.property == "totalPriceAfterTax")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += '';
          // if (column.property == "quantity") {
          //   sums[index] += "";
          // } else {
          sums[index] = numFilter(sums[index]);
          // }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>
<style scoped lang="scss">
// @import "@/assets/css/commonLayout.scss";
/deep/.el-button--primary {
  min-width: 60px;
}
/deep/.el-button--info {
  min-width: 60px;
}
.EngineerList {
  // min-width: 1480px;
  overflow: auto;
  margin-top: 20px;
  .operatePanel {
    text-align: right;
  }
}
</style>
